import { type Story, StoryVisibility } from '@/@types/story'
import day, { formatAsRelativeTime } from '@/utils/day'
import styles from './StoryHeader.module.css'

export interface StoryHeaderProps {
	story: Story
}

export default function StoryHeader({ story }: StoryHeaderProps) {
	const avatarUrl =
		story.user.avatarImage.thumbnailUrl ??
		story.user.profileImageUrl ??
		story.user.avatarImage.picUrl
	const visibilityLabel =
		story.status === StoryVisibility.PRIVATE
			? '仅自己可见'
			: story.status === StoryVisibility.EXPIRED
				? '已存档'
				: undefined

	return (
		<header className={styles.header}>
			<div className={styles.author}>
				<div className={styles.avatar}>
					{avatarUrl ? (
						<img
							src={avatarUrl}
							alt={`${story.user.screenName}的头像`}
							referrerPolicy="no-referrer"
						/>
					) : (
						<span aria-hidden="true">{story.user.screenName.slice(0, 1)}</span>
					)}
				</div>
				<div className={styles.authorText}>
					<strong className={styles.screenName}>{story.user.screenName}</strong>
					<div className={styles.metadata}>
						<span>{formatAsRelativeTime(story.createdAt)}</span>
						{visibilityLabel && <span>{visibilityLabel}</span>}
						{story.emoji && <span aria-label={`心情 ${story.emoji}`}>{story.emoji}</span>}
					</div>
				</div>
			</div>
			<time className={styles.date} dateTime={story.createdAt}>
				<span className={styles.dateDay}>{day(story.createdAt).format('DD')}</span>
				<span className={styles.dateMonth}>{day(story.createdAt).format('M月')}</span>
			</time>
		</header>
	)
}
